import {
  Box,
  Button,
  Container,
  Heading,
  Text,
  VStack,
  useToast,
  useDisclosure,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
} from '@chakra-ui/react';
import { useState, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { deleteOrganization, removeOrgDataFromStorage } from '../services/organization';

const DeleteOrganizationComponent = () => {
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const { orgId } = useParams();
  const navigate = useNavigate();

  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = useRef(null);

  const handleDelete = async () => {
    setLoading(true);
    try {
      const response = await deleteOrganization(orgId);
      if (response?.success) {
        toast({
          title: 'Organization Deleted',
          description: 'The organization was successfully deleted.',
          status: 'success',
          duration: 4000,
          isClosable: true,
        });
        removeOrgDataFromStorage();
        window.location.href = "/home";
      } else {
        throw new Error('Failed to delete organization');
      }
    } catch (error) {
      toast({
        title: 'Deletion Failed',
        description: 'An error occurred while deleting the organization.',
        status: 'error',
        duration: 4000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
      onClose();
    }
  };

  return (
    <Container w={"100%"} py={6}>
      <VStack spacing={6} align="flex-start">
        <Box p={6} borderWidth={1} borderRadius="lg" boxShadow="md" bg="white">
          <VStack align="start" spacing={4}>
            <Text fontSize="md">
              This action will permanently delete the organization and all associated data. This cannot be undone.
            </Text>
            <Button colorScheme="red" onClick={onOpen}>
              Delete Organization
            </Button>
          </VStack>
        </Box>
      </VStack>

      {/* Confirmation Dialog */}
      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Confirm Deletion
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure you want to delete this organization? This action cannot be undone.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancel
              </Button>
              <Button
                colorScheme="red"
                onClick={handleDelete}
                ml={3}
                isLoading={loading}
              >
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Container>
  );
};

export default DeleteOrganizationComponent;
